import React from 'react';
import './buttons.scss';

/**
 * FancyIconButton — reusable icon-only button.
 *
 * Props:
 *   variant: 'primary' | 'secondary' | 'danger' | 'ghost' | 'text'   (default 'ghost')
 *   size:    'sm' | 'md' | 'lg'                                      (default 'md')
 *   shape:   'circle' | 'square'                                     (default 'circle')
 *   loading: boolean
 *   disabled: boolean
 *   ariaLabel: string — required for accessibility
 *   onClick, style, className, children (the icon)
 */
export const FancyIconButton = React.forwardRef(function FancyIconButton(
  {
    variant = 'ghost',
    size = 'md',
    shape = 'circle',
    loading = false,
    disabled = false,
    ariaLabel,
    onClick,
    style,
    className = '',
    children,
    ...rest
  },
  ref
) {
  const isDisabled = disabled || loading;

  const classes = [
    'fancy-icon-btn',
    `fancy-btn--${variant}`,
    `fancy-icon-btn--${size}`,
    `fancy-icon-btn--${shape}`,
    loading ? 'is-loading' : '',
    isDisabled ? 'is-disabled' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      ref={ref}
      type="button"
      className={classes}
      style={style}
      onClick={isDisabled ? undefined : onClick}
      disabled={isDisabled}
      aria-label={ariaLabel}
      aria-busy={loading || undefined}
      {...rest}
    >
      <span className="fancy-btn__shine" aria-hidden="true" />
      {loading ? (
        <span className="fancy-btn__spinner" aria-hidden="true" />
      ) : (
        <span className="fancy-icon-btn__inner">{children}</span>
      )}
    </button>
  );
});
